import React from 'react';

import { FileProtectOutlined } from '@ant-design/icons';

function InspectionCard({ vehicleRegister, arrIdSelectVendor, reportDrivingLicenseList }) {
  const vehicleRegisterData = [
    {
      label: 'Đã hết hạn',
      total: vehicleRegister?.hetHanDangKiem?.length || 0,
      totalBg: 'danger',
      url: `/report-vehicle?id=${arrIdSelectVendor}&key=hetHanDangKiem`,
    },
    {
      label: 'Còn 10 ngày',
      total: vehicleRegister?.hetHanDangKiem10?.length || 0,
      totalBg: 'orange',
      url: `/report-vehicle?id=${arrIdSelectVendor}&key=hetHanDangKiem10`,
    },
    {
      label: 'Còn 20 ngày',
      total: vehicleRegister?.hetHanDangKiem20?.length || 0,
      totalBg: '',
      url: `/report-vehicle?id=${arrIdSelectVendor}&key=hetHanDangKiem20`,
    },
    {
      label: 'Còn 30 ngày',
      total: vehicleRegister?.hetHanDangKiem30?.length || 0,
      totalBg: '',
      url: `/report-vehicle?id=${arrIdSelectVendor}&key=hetHanDangKiem30`,
    },
    {
      label: 'Hết hạn phù hiệu',
      total: vehicleRegister?.hetHanPhuHieu?.length || 0,
      totalBg: 'danger',
      url: `/report-vehicle?id=${arrIdSelectVendor}&key=hetHanPhuHieu`,
    },
    {
      label: 'Hết hạn bảo hiểm',
      total: vehicleRegister?.hetHanBaoHiem?.length || 0,
      totalBg: 'danger',
      url: `/report-vehicle?id=${arrIdSelectVendor}&key=hetHanBaoHiem`,
    },
  ];

  const drivingLicenseListData = [
    {
      label: 'Đã hết hạn',
      total: reportDrivingLicenseList?.HetHan?.length || 0,
      totalBg: 'danger',
      url: `/report-driving-license?key=HetHan`,
    },
    {
      label: 'Còn 10 ngày',
      total: reportDrivingLicenseList?.HetHan10?.length || 0,
      totalBg: 'orange',
      url: `/report-driving-license?key=HetHan10`,
    },
    {
      label: 'Còn 20 ngày',
      total: reportDrivingLicenseList?.HetHan20?.length || 0,
      totalBg: '',
      url: `/report-driving-license?key=HetHan20`,
    },
  ];

  return (
    <div className='card'>
      <div className='card-header'>
        <FileProtectOutlined className='card-icon green' />
        <h3 className='card-title'>Hạn Đăng Kiểm Xe</h3>
      </div>

      {vehicleRegisterData.map((item) => {
        const clickable = item.total > 0;
        return (
          <div
            key={item.label}
            className={`row ${clickable ? 'clickable' : ''}`}
            onClick={clickable ? () => window.open(item.url, '_blank') : undefined}
          >
            <span>{item.label}</span>
            <b className={item.totalBg}>{item.total}</b>
          </div>
        );
      })}

      <div className='card-header'>
        <FileProtectOutlined className='card-icon green' />
        <h3 className='card-title'>Giấy Phép Lái Xe</h3>
      </div>

      {drivingLicenseListData.map((item) => {
        const clickable = item.total > 0;

        return (
          <div
            key={item.label}
            className={`row ${clickable ? 'clickable' : ''}`}
            onClick={clickable ? () => window.open(item.url, '_blank') : undefined}
          >
            <span>{item.label}</span>
            <b className={item.totalBg}>{item.total}</b>
          </div>
        );
      })}
    </div>
  );
}

export default InspectionCard;
